import { isManuscriptStagingToolName } from "./manuscriptStagingThinking";

/** Read-only manage_project_documents ops — navigation/inspection, not mutations. */
export const MANAGE_PROJECT_DOCUMENTS_READ_ONLY_OPS = new Set([
  "switch_document",
  "scan_document_chapters",
]);

export function isManageProjectDocumentsReadOnlyOperation(operation: unknown): boolean {
  return typeof operation === "string" && MANAGE_PROJECT_DOCUMENTS_READ_ONLY_OPS.has(operation);
}

/** Whether a tool_start should mark the thinking timeline row as a write/edit task. */
export function isThinkingWriteToolStart(
  toolName: string,
  toolArgs?: Record<string, unknown> | null,
): boolean {
  const name = toolName.toLowerCase();
  if (isManuscriptStagingToolName(name)) {
    return true;
  }
  if (name === "manage_project_documents") {
    if (isManageProjectDocumentsReadOnlyOperation(toolArgs?.operation)) {
      return false;
    }
    return true;
  }
  return (
    name === "apply_manuscript_edits" // historical thinking rows
    || name === "mutate_manuscript_comments"
    || name.includes("mutate")
    || name.includes("update")
    || name.includes("create")
    || name.includes("delete")
    || name.includes("generate")
    || name.includes("reorder")
  );
}
